export default "__VITE_ASSET__B7N6cS32__"